import { render, staticRenderFns } from "./SalonGeneral.vue?vue&type=template&id=921d5b84"
import script from "./SalonGeneral.vue?vue&type=script&lang=ts"
export * from "./SalonGeneral.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports